(() => {
  angular
    .module('app.campaign')
    .config(($routeProvider, $locationProvider) => {

    $locationProvider.html5Mode(true);

    $routeProvider
      .when('/:mode/:cid?/:cloneStrategy?/details', {
        templateUrl: `../../assets/js/app/campaign/partials/details.html?v=${window.BUILD_VERSION}`,
        controller: 'CampaignDetailsController',
        controllerAs: 'campaignDetails',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route),
          SupportedCountriesData: CampaignManagerService => CampaignManagerService.countriesPromise,
          AccountLabelsData: CampaignManagerService => CampaignManagerService.labelsPromise
        }
      })
      .when('/:mode/:cid?/:cloneStrategy?/trackingpoints', {
        templateUrl: `../../assets/js/app/campaign/partials/trackingpoints.html?v=${window.BUILD_VERSION}`,
        controller: 'CampaignTrackingPointsController',
        controllerAs: 'campaignTrackingpoints',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/:mode/:cid?/:cloneStrategy?/sources', {
        templateUrl: `../../assets/js/app/campaign/partials/sources.html?v=${window.BUILD_VERSION}`,
        controller: 'CampaignSourcesController',
        controllerAs: 'campaignSources',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/:mode/:cid?/:cloneStrategy?/targetgroup', {
        templateUrl: `../../assets/js/app/campaign/partials/targetgroup.html?v=${window.BUILD_VERSION}`,
        controller: 'CampaignTargetGroupController',
        controllerAs: 'campaignTargetGroup',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route),
          CustomSegmentsData: CampaignManagerService => CampaignManagerService.customSegmentsPromise
        }
      })
      .when('/:mode/:cid?/:cloneStrategy?/reportperiod', {
        templateUrl: `../../assets/js/app/campaign/partials/dateperiod.html?v=${window.BUILD_VERSION}`,
        controller: 'CampaignReportPeriodController',
        controllerAs: 'campaignReportPeriod',
        resolve: {
          CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route)
        }
      })
      .when('/:mode/:cid?/:cloneStrategy?/quality', {
          templateUrl: `../../assets/js/app/campaign/partials/quality.html?v=${window.BUILD_VERSION}`,
          controller: 'CampaignQualityController',
          controllerAs: 'campaignQuality',
          resolve: {
            CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route),
            CustomSegmentsData: CampaignManagerService => CampaignManagerService.customSegmentsPromise,
            AvailableQualityMetrics: (CampaignManagerService, $route) => (
              CampaignManagerService.availableQualityMetrics($route.current.params.cid, $route.current.params.mode)),
          }
      })
      .when('/:mode/:cid?/:cloneStrategy?/dms', {
          templateUrl: `../../assets/js/app/campaign/partials/dms.html?v=${window.BUILD_VERSION}`,
          controller: 'CampaignDmsController',
          controllerAs: 'campaignDms',
          resolve: {
            CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route),
          }
      })
      .when('/:mode/:cid?/:cloneStrategy?/techedge', {
          templateUrl: `../../assets/js/app/campaign/partials/techedge.html?v=${window.BUILD_VERSION}`,
          controller: 'CampaignTechedgeController',
          controllerAs: 'campaignTechedge',
          resolve: {
            CampaignData: ($route, CampaignManagerService) => CampaignManagerService.getCampaignPromise($route),
          }
      });
  });
})();
